import { Form, Formik } from 'formik';

import { Button } from '../../../cdl/Button/Button';
import { FormikInput } from '../../../cdl/Input/FormikInput';
import { Modal } from '../../../cdl/Modal/Modal';
import { Text } from '../../../cdl/Text/Text';
import { ButtonGroup } from '../../../common/buttons/ButtonGroup';
import { FormikProductSelect } from '../../../common/form-elements/formik/FormikProductSelect';
import { translate } from '../../../common/helpers/translate.helper';
import { useVesselDefaultProducts } from '../../../common/hooks/useVesselDefaultProducts';
import { Box } from '../../../common/ui/Box';

interface VesselProductFormikState {
    productId: string;
    note: string;
}

interface VesselProductModalProps {
    isOpen: boolean;
    onDismiss: () => void;
    onSubmit: (values: VesselProductFormikState) => Promise<void>;
    initialValues: VesselProductFormikState;
    title: string;
    isLoading: boolean;
    vesselId: string;
    excludedProductIds?: string[];
}

export const VesselProductModal = ({
    isOpen,
    onDismiss,
    onSubmit,
    initialValues,
    title,
    isLoading,
    vesselId,
    excludedProductIds,
}: VesselProductModalProps) => {
    const defaultProducts = useVesselDefaultProducts({ vesselId });

    const handleSubmit = async (values: VesselProductFormikState) => {
        await onSubmit(values);
        onDismiss();
    };

    return (
        <Modal isOpen={isOpen} onDismiss={onDismiss} size="medium" scrollable={false}>
            <Formik initialValues={initialValues} onSubmit={handleSubmit}>
                {() => (
                    <Form>
                        <Box padding={24} display="grid" rowGap={24}>
                            <Text variant="title">{title}</Text>

                            <Box display="grid" rowGap={16}>
                                <FormikProductSelect
                                    name="productId"
                                    label={translate('vessel.products.modal.product')}
                                    defaultProducts={defaultProducts}
                                    excludedProductIds={excludedProductIds}
                                    hideSuccessorProduct
                                    vesselId={vesselId}
                                />

                                <FormikInput name="note" label={translate('vessel.products.modal.note')} />
                            </Box>

                            <ButtonGroup justifyContent="end">
                                <Button onClick={onDismiss} type="button">
                                    {translate('actions.cancel')}
                                </Button>
                                <Button type="submit" emphasis="high" isLoading={isLoading}>
                                    {translate('actions.save')}
                                </Button>
                            </ButtonGroup>
                        </Box>
                    </Form>
                )}
            </Formik>
        </Modal>
    );
};
